import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Alert, Modal } from 'antd';

const EditForm = ({
  visible,
  selectedMerch,
  error,
  submitting,
  handleCloseForm,
  handleSubmitForm,
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      handleSubmitForm(values);
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  return (
    <Modal
      open={visible}
      footer={false}
      title="Üye İşyeri Düzenleme"
      onCancel={handleCloseForm}
      destroyOnClose
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical" initialValues={selectedMerch}>
        <Form.Item
          name="contactName"
          label="İletişim Adı"
          rules={[{ required: true, message: 'Zorunlu Alan' }]}
        >
          <Input className="input__default" />
        </Form.Item>
        <Form.Item
          name="contactEmail"
          label="İletişim Maili"
          rules={[
            { required: true, message: 'Zorunlu Alan' },
            { type: 'email', message: 'Geçersiz mail adresi!' },
          ]}
        >
          <Input className="input__default" placeholder="E-Posta" />
        </Form.Item>
        <Form.Item
          name="contactGsm"
          label="İletişim Numarası"
          rules={[{ required: true, message: 'Zorunlu Alan' }]}
        >
          <Input className="input__default" />
        </Form.Item>
        <Form.Item
          name="emailForArchive"
          label="Arşiv Maili"
          rules={[
            { required: true, message: 'Zorunlu Alan' },
            { type: 'email', message: 'Geçersiz mail adresi!' },
          ]}
        >
          <Input className="input__default" placeholder="E-Posta" />
        </Form.Item>
        {error && (
          <Form.Item>
            <Alert message={error} type="error" showIcon />
          </Form.Item>
        )}
        <Form.Item className="text-align-right">
          <Button
            className="button button__outline mr-3"
            type="ghost"
            htmlType="button"
            disabled={submitting}
            onClick={handleCloseForm}
          >
            Vazgeç
          </Button>
          <Button
            className="button button__fill"
            type="primary"
            htmlType="submit"
            disabled={submitting}
            loading={submitting}
          >
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

EditForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  selectedMerch: PropTypes.shape({
    contactName: PropTypes.string,
    contactEmail: PropTypes.string,
    contactGsm: PropTypes.string,
    emailForArchive: PropTypes.string,
  }).isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  handleCloseForm: PropTypes.func.isRequired,
  handleSubmitForm: PropTypes.func.isRequired,
};

EditForm.defaultProps = {
  error: null,
};

export default EditForm;
